export default __webpack_public_path__ + "static/media/IconDesc_EncasedSteelBeam.256.1750a35b.png";